import angular from "angular";
import bookingForm from "./booking-form/booking-form";
import bookingModule from "./booking-module/booking-module";

angular.module('bookingModule', [
    bookingForm,
    bookingModule
]);


export default 'bookingModule';


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/booking-module.module.js